"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const malty_atoms_icon_wrapper_1 = require("@carlsberggroup/malty.atoms.icon-wrapper");
const react_1 = __importDefault(require("react"));
const Sent = (props) => (0, malty_atoms_icon_wrapper_1.IconWrapper)(props, react_1.default.createElement("g", { fillRule: "evenodd" },
    react_1.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
    react_1.default.createElement("path", { d: "M3.66 4.18c-.397-.824.42-1.678 1.238-1.376l.116.051 16.314 8.314a1 1 0 010 1.782L5.014 21.265c-.852.434-1.77-.462-1.355-1.325l3.791-7.881zM16.823 13H9.217l-2.471 5.136zM6.747 5.98L9.16 11h7.433z" })));
exports.default = Sent;
//# sourceMappingURL=index.js.map